import { ReactNode } from 'react';
import { cn } from '../../lib/helpers';

interface TooltipProps {
    label: string | ReactNode;
    children: ReactNode;
    className?: string;
    placement?: 'top' | 'bottom' | 'left' | 'right';
}

export default function Tooltip({
    label,
    children,
    className = '',
    placement = 'top'
}: TooltipProps) {
    const placementClasses = {
        top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
        bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
        left: 'right-full top-1/2 -translate-y-1/2 mr-2',
        right: 'left-full top-1/2 -translate-y-1/2 ml-2',
    };

    return (
        <span className={cn('relative group inline-block', className)}>
            {children}
            <div
                className={cn(
                    'pointer-events-none absolute z-50',
                    'opacity-0 transition-opacity duration-300 ease-in-out',
                    'group-hover:opacity-100 group-focus-within:opacity-100',
                    placementClasses[placement]
                )}
                role="tooltip"
            >
                {/* Speech bubble container */}
                <div className="relative mb-1">
                    {/* Main speech bubble */}
                    <div className="relative bg-cloud-100 border border-product-500 rounded-md px-4 py-2 shadow-sm">
                        {/* Text content */}
                        <p className="font-display font-semibold text-sm text-ink-800 whitespace-nowrap">
                            {typeof label === 'string' ? <span dangerouslySetInnerHTML={{ __html: label as string }} /> : label}
                        </p>

                        {/* Speech bubble tail pointing down */}
                        <div className="absolute top-full left-1/2 -translate-x-1/2">
                            <div className="w-0 h-0 border-l-[8px] border-r-[8px] border-t-[8px] border-l-transparent border-r-transparent border-t-product-500"></div>
                            <div className="absolute top-[-1px] left-1/2 -translate-x-1/2 w-0 h-0 border-l-[7px] border-r-[7px] border-t-[7px] border-l-transparent border-r-transparent border-t-cloud-100"></div>
                        </div>
                    </div>
                </div>
            </div>
        </span>
    );
}

// return (
//     <span className={`relative group ${className}`}>
//         {children}
//         <span className="pointer-events-none absolute left-1/2 top-full z-10 mt-2 w-max -translate-x-1/2 rounded bg-gray-800 px-2 py-1 text-xs text-white opacity-0 transition-opacity group-hover:opacity-100">
//             <div dangerouslySetInnerHTML={{ __html: label }} />
//         </span>
//     </span>
// );

